import { WorkflowNodeId } from '@ply-io/ply-front-shared-utilities';
import { api } from './clients';

export const getNodesByIds = (nodeIds: WorkflowNodeId[] = []) => {
	const params = new URLSearchParams();
	nodeIds.forEach((nodeId) => params.append('id', String(nodeId)));
	return api.get(`workflow-nodes/?${params.toString()}`);
};
